<div class="modal-content">
    <div class="modal-body p-5">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <h5>{{'New Update(s) Detected !'}}</h5>
                    <p class="text-primary text-justify">New update is released. It is recommended that you to update your application to the latest version to view the changes.</p>
                    <p>Please refresh to continue. . .</p>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-sm-12">
              <div class="form-button">
                <button id="submit" type="button" (click)="onUpdateNewChanges()" class="btn btn-sm w-100 btn-block btn-outline-primary btn-sm action_buttons">{{'Reload'}}</button>
            </div>
            </div>
          </div>
    </div>
  </div>
  